export const STATUS_ID = 'costStatus';
